module.exports = __webpack_public_path__ + "static/dictionary-computer-0cf0447ca1f3eab78e5844e2a05d5e9b.png";